import { render, staticRenderFns } from "./PersonalFrom.vue?vue&type=template&id=3e054177&scoped=true"
import script from "./PersonalFrom.vue?vue&type=script&lang=js"
export * from "./PersonalFrom.vue?vue&type=script&lang=js"
import style0 from "./PersonalFrom.vue?vue&type=style&index=0&id=3e054177&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e054177",
  null
  
)

export default component.exports